import { Progress, Spin, message } from "antd";
import axios from "axios";
import { UseLazyApiCallV2 } from "hooks/use-lazy-api-call-v2";
import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components";
import { useCurrentUserContext } from "providers";
import { FileCancelIcon, UploadIcon } from "icons";
import { useParams } from "react-router-dom";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { ExtractedDataModal } from "pages/cases-detail/components/extractedDataModal";
import { clientMasterData, formFields } from "pages/cases-detail/constants";
import { Tabs } from "../tabs";
import { useRecoilState } from "recoil";
import { caseStatus } from "store/atom";

export const FileUpload = ({
  fileData,
  refetchLegalDocs,
  refetchUploaded,
  refetchDetail,
  refetchAllUploadedFiles,
  dropdownsListObj,
  refetchCount,
}) => {
  const { translator } = useLanguageTranslator();
  const uploadFileTrans = translator("caseDetail.uploadFiles");
  const [selectedFile, setSelectedFile] = useState(null);
  const [binaryFile, setBinaryFile] = useState("");
  const [signedUrl, setSignedUrl] = useState("");
  const [progress, setProgress] = useState(0);
  const [remainingTime, setRemainingTime] = useState(null);
  const [cancelToken, setCancelToken] = useState(null);
  // const [uniqueFileName, setUniqueFileName] = useState("");
  const { user } = useCurrentUserContext();
  const [openExtractedDetail, setOpenExtractedDetails] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [extractedData, setExtractedData] = useState([]);
  const [activeTab, setActiveTab] = useState("basic");
  const [uniqueFileNameFromDB, setUniqueFileNameFromDB] = useState("");
  const { caseId } = useParams();
  const [caseStatusOpenOrClosed, setCaseStatusOpenOrClosed] =
    useRecoilState(caseStatus);
  const getQueriesEndPoint = "/get_queries";
  const tabsArr = [
    {
      key: "basic",
      title: "Basic",
    },
    {
      key: "advanced",
      title: "Advanced",
    },
  ];

  async function refetchUploads() {
    await refetchUploaded();
  }

  useEffect(() => {
    refetchUploads();
  }, [fileData?.key]);

  // function convertToArrOfObjects(data1, fields) {
  //   if (!data1 || !fields) return [];

  //   return Object.keys(data1).map((key) => {
  //     const field = fields.find((f) => f.key === key);

  //     return {
  //       id: field?.id ?? null, // use id if found, otherwise null
  //       key,
  //       Answer: data1[key]?.Answer ?? "", // ✅ only take the Answer string
  //       Confidence: data1[key]?.Confidence ?? null, // keep Confidence if needed
  //       Query: key,
  //       checked: true,
  //       label: translator(`caseDetail.form.${key}`),
  //     };
  //   });
  // }
  function filterFieldsByApiDataWithChildAnswers(
    totalFields,
    apiData,
    dropdownsListObj = {},
  ) {
    if (!totalFields || !apiData) return [];

    const apiKeys = new Set(Object.keys(apiData));

    return totalFields
      .map((field) => {
        // Parent field: keep only sections that have childs present in apiData
        if (field.isParent && Array.isArray(field.sections)) {
          const filteredSections = field.sections
            .map((section) => {
              const filteredChilds = (section.childs || [])
                .filter(
                  (child) =>
                    apiKeys.has(child.key) &&
                    apiData[child.key] != null &&
                    apiData[child.key] !== "",
                ) // keep only childs present in API
                .map((child) => ({
                  // keep original child properties but add Answer/Query/checked/dropdownList
                  ...child,
                  Answer: apiData[child.key],
                  Query: child.key,
                  checked: true,
                  dropdownList: dropdownsListObj[child.key] || [],
                }));

              return filteredChilds.length > 0
                ? { ...section, childs: filteredChilds }
                : null;
            })
            .filter(Boolean);

          // Keep parent only if parent key exists in API OR it has at least one matching child
          if (apiKeys.has(field.key) || filteredSections.length > 0) {
            return {
              ...field,
              Answer: apiData[field.key],
              Query: field.key,
              checked: !!apiData[field.key],
              sections: filteredSections,
            };
          }

          return null; // drop parent completely if no relevant keys
        }

        // Non-parent standalone field: keep only if present in API
        if (
          apiKeys.has(field.key) &&
          apiData[field.key] != null &&
          apiData[field.key] !== ""
        ) {
          return {
            ...field,
            Answer: apiData[field.key],
            Query: field.key,
            checked: true,
            dropdownList: dropdownsListObj[field.key] || [],
          };
        }

        return null; // drop if not in API
      })
      .filter(Boolean);
  }

  const [
    extracteDataFromFile,
    {
      data: extracteDataFromFileData,
      isLoading: extracteDataFromFileLoading,
      error: extracteDataFromFileError,
    },
  ] = UseLazyApiCallV2({
    url: getQueriesEndPoint,
    // url: "/get_queries",
    method: "POST",
  });
  const [
    extractTextFromFileAdv,
    {
      data: extractTextFromFileAdvData,
      isLoading: extractTextFromFileAdvLoading,
      error: extractTextFromFileAdvError,
    },
  ] = UseLazyApiCallV2({
    url: "/extract_text",
    method: "POST",
  });
  const [
    gptQueriesAdv,
    {
      data: gptQueriesAdvData,
      isLoading: gptQueriesAdvLoading,
      error: gptQueriesAdvError,
    },
  ] = UseLazyApiCallV2({
    url: "/get_gpt_query_revised",
    method: "POST",
  });

  const [
    uploadSuccess,
    {
      data: uploadSuccessData,
      isLoading: uploadSuccessLoading,
      error: uploadSuccessError,
    },
  ] = UseLazyApiCallV2({
    url: "/upload_success",
    method: "POST",
    paramsData: {
      email: user?.email,
      documentType: fileData?.key,
      case_id: caseId,
      status: true,
    },
  });
  const [queries, setQueries] = useState([]);
  const [extractedKeysForm, setExtractedKeysForm] = useState({});

  // useEffect(() => {
  //   const dataWithCheckedKey = extracteDataFromFileData?.Answers?.map(
  //     (item) => ({
  //       ...item,
  //       checked: true,
  //     })
  //   );

  //   setQueries(dataWithCheckedKey);
  // }, [extracteDataFromFileData]);

  const [
    uploadFile,
    {
      data: uploadFileData,
      isLoading: uploadFileLoading,
      error: uploadingVideoError,
    },
  ] = UseLazyApiCallV2({
    url: "/upload_file",
    method: "POST",
  });

  useEffect(() => {
    if (!!binaryFile && signedUrl) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      const source = axios.CancelToken.source();
      setCancelToken(source);
      uploadOnBucket();
    }
  }, [binaryFile, signedUrl]);

  useEffect(() => {
    return () => {
      if (cancelToken) {
        cancelToken.cancel("Component unmounted: Upload canceled");
      }
    };
  }, [cancelToken]);

  function startUploading({ file }) {
    setSelectedFile(file);
    handleUpload(file);
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    startUploading({ file });
  };

  const calculateRemainingTime = (startTime, uploaded, totalSize) => {
    const currentTime = Date.now();
    const elapsedTime = (currentTime - startTime) / 1000; // in seconds
    const uploadedPerSecond = uploaded / elapsedTime;
    const remainingSize = totalSize - uploaded;
    const remainingTimeSeconds = remainingSize / uploadedPerSecond;
    return remainingTimeSeconds;
  };

  async function uploadOnBucket() {
    const startTime = Date.now();
    const source = axios.CancelToken.source();
    setCancelToken(source);
    setUploading(true);
    try {
      const response = await axios.put(signedUrl, binaryFile, {
        headers: {
          withCredentials: true,
          "Content-type": selectedFile.type,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setProgress(percentCompleted);
          const remainingTimeSeconds = calculateRemainingTime(
            startTime,
            progressEvent.loaded,
            progressEvent.total,
          );
          setRemainingTime(remainingTimeSeconds);
        },
        cancelToken: source.token,
      });
      if (response?.status === 200) {
        message.success(translator("caseDetail.uploadFiles.uploadedSuccess"));
        await uploadSuccess();
        await refetchLegalDocs();
        await refetchUploaded();
        await refetchAllUploadedFiles();
        await refetchCount();

        const params = {
          caseId,
          documentType: fileData?.key,
          fileName: uniqueFileNameFromDB,
        };

        message.success(translator("caseDetail.uploadFiles.scanningToExtract"));
        if (activeTab === "basic") {
          const res = await extracteDataFromFile({
            params,
          });
          const arrOfObjects = filterFieldsByApiDataWithChildAnswers(
            [...formFields, ...clientMasterData],
            res?.data,
          );
          setExtractedKeysForm({ ...res?.data });
          setQueries([...arrOfObjects]);
          if (res) {
            // setAllStatesToDefault();
            setOpenExtractedDetails(true);
            //   setLoading(false);
          } else {
            const fileInput = document.getElementById("file-input");
            if (fileInput) {
              fileInput.value = "";
            }
          }
        } else if (activeTab === "advanced") {
          try {
            const extractRes = await extractTextFromFileAdv({
              params,
            });

            if (extractRes) {
              try {
                const res = await gptQueriesAdv({
                  params: {
                    textId: extractRes?.textId,
                  },
                });

                const arrOfObjects = filterFieldsByApiDataWithChildAnswers(
                  [...formFields, ...clientMasterData],
                  res?.data,
                );
                setExtractedKeysForm({ ...res?.data });
                setQueries([...arrOfObjects]);
                if (res) {
                  setOpenExtractedDetails(true);
                } else {
                  const fileInput = document.getElementById("file-input");
                  if (fileInput) {
                    fileInput.value = "";
                  }
                }
              } catch (error) {
                setAllStatesToDefault();
              }
            } else {
              setAllStatesToDefault();
            }
          } catch (error) {
            setAllStatesToDefault();
          }
        }
      }
    } catch (error) {
      message.error(`${error?.message}`);
      setAllStatesToDefault();
    } finally {
      setUploading(false);
    }
  }

  const handleUpload = async (file) => {
    if (cancelToken) {
      cancelToken.cancel("Upload canceled");
    }

    const reader = new FileReader();
    if (file) {
      reader.readAsArrayBuffer(file);

      reader.addEventListener("load", () => setBinaryFile(reader.result));
      try {
        const response = await uploadFile({
          params: {
            fileName: file?.name,
            documentType: fileData?.key,
            email: user?.email,
            caseId,
          },
        });

        if (response) {
          setSignedUrl(response.upload_url);
          setUniqueFileNameFromDB(response?.fileName);
        }
      } catch (error) {
        setAllStatesToDefault();
      }
    }
  };
  function handleCloseExtractedDetails() {
    setOpenExtractedDetails(false);
    setAllStatesToDefault();
  }

  function handleClickBrowse() {
    // setOpenExtractedDetails(true);
    if (!!selectedFile) return;
    setAllStatesToDefault();
    document.getElementById("file-input").click();
  }
  function setAllStatesToDefault() {
    setSelectedFile(null);
    setBinaryFile("");
    setProgress(0);
    setSignedUrl("");
    // reset file input element also
    const fileInput = document.getElementById("file-input");
    if (fileInput) {
      fileInput.value = "";
    }
  }

  const cancelUpload = () => {
    if (cancelToken) {
      cancelToken.cancel("Upload canceled");

      setAllStatesToDefault();
      message.error("uploading cancelled");
    }
  };

  function handleDropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    startUploading({ file });
  }
  function handleDragOver(e) {
    e.preventDefault();
  }

  return (
    <Spin
      tip={uploading && translator("caseDetail.uploadFiles.scanning")}
      spinning={uploadFileLoading || extracteDataFromFileLoading || uploading}
    >
      <div
        className={styles.uploadContainer}
        onDrop={handleDropFile}
        onDragOver={handleDragOver}
        id="file-upload"
        style={{ position: "relative" }}
      >
        <div
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
            width: "41.2dvh",
          }}
        >
          <Tabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabsArr={tabsArr}
          />
        </div>
        <div className={styles.upload}>
          <UploadIcon />
          <div className={styles.labels}>
            <p className={styles.label}>
              {uploadFileTrans.addFilesInstruction}{" "}
            </p>
            <div className={styles.compatibility}>
              {uploadFileTrans.acceptableFormats}
            </div>
          </div>
          <button
            onClick={handleClickBrowse}
            disabled={caseStatusOpenOrClosed === "closed"}
            className={
              caseStatusOpenOrClosed === "closed" ? styles.disabledBtn : ""
            }
          >
            {uploadFileTrans.uploadBtnText}
          </button>
        </div>
        <input
          style={{ display: "none" }}
          id="file-input"
          type="file"
          onChange={handleFileChange}
          accept=".pdf"
        />
        <div className={styles.fileUploadingStatus}>
          <ConditionalRenderer
            condition={!!selectedFile && progress > 0 && progress < 100}
          >
            <div className={styles.fileProgress}>
              {translator("uploadingInProgress")}
            </div>
            <div className={styles.fileStatus}>
              <div className={styles.fileNameAndIcon}>
                <div className={styles.filename}>
                  {selectedFile?.name || "--"}
                </div>
                <FileCancelIcon
                  onClick={cancelUpload}
                  className={styles.cancelIcon}
                />
              </div>
              <ConditionalRenderer condition={progress > 0}>
                <Progress
                  strokeLinecap="butt"
                  percent={progress}
                  strokeColor="#CD2A3F"
                  strokeWidth={4}
                  showInfo={false}
                />
              </ConditionalRenderer>
            </div>
          </ConditionalRenderer>
        </div>
      </div>
      <ExtractedDataModal
        handleCloseModal={handleCloseExtractedDetails}
        open={openExtractedDetail}
        queries={queries}
        setQueries={setQueries}
        refetchDetail={refetchDetail}
        documentType={fileData?.key}
        fileName={uniqueFileNameFromDB}
        dropdownsListObj={dropdownsListObj}
        extractedKeysForm={extractedKeysForm}
        setExtractedKeysForm={setExtractedKeysForm}
      />
    </Spin>
  );
};
